// extracted by mini-css-extract-plugin
export default {"card":"PriceCard_card__DqQk8","price":"PriceCard_price__p304W","content":"PriceCard_content__IYEBw"};